import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { IndexWrapper } from "@framework/shared";

import { BreedBreeds } from "./breeds";
import { BreedSection } from "../../../dashboard/mechanics/breed";

export const breedRoutes: Array<RouteObject> = [
  {
    path: "/breed",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="breed">
            <BreedSection />
          </IndexWrapper>
        ),
      },
      {
        path: "/breed/breeds",
        element: <Protected />,
        children: [
          { index: true, element: <BreedBreeds /> },
          { path: "/breed/breeds/:id/:action", element: <BreedBreeds /> },
        ],
      },
    ],
  },
];
